import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'

function ProductImageAndSpecs({ descriptionWithIcons, subtitle }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.title}>
          { descriptionWithIcons.map(d => renderTextAndIcon(d.text, d.icon))}
        </div>
        <div className={styles.subtitle}>
          <SimpleBlockContent blocks={subtitle} noSpace/>
        </div>
      </div>
    </div>
  )
}

const renderTextAndIcon = (text, icon) => {
  return (
    <div className={styles.textAndIcon}>
      {icon && (
        // Small inline icon — plain <img> (task #67, no next/image). No srcset
        // needed at 24px; the loader still maps /assets/* to a WebP variant.
        // eslint-disable-next-line @next/next/no-img-element
        // eslint-disable-next-line local-rules/prefer-img-component -- inline content icon, hand-sized 24x24; a full <Img> descriptor box is unnecessary at this size
        <img
          src={icon?.src}
          alt=""
          width={24}
          height={24}
          decoding="async"
          loading="lazy"
          style={{ width: 'auto', height: 'auto' }}
        />
      )}
      <SimpleBlockContent
        blocks={text}
        noSpace
      />
    </div>
  )
}

export default ProductImageAndSpecs
